import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { QuestionService } from '@services/question.service';
import { QuestionSubTypeIdEnum, QuestionTypeIdEnum, ScoringTypeEnum } from '@configs/questions.config';
import { TranslateService } from '@ngx-translate/core';
import { ItemService } from '@services/item.service';
import { Subscription } from 'rxjs';
import { Editor, NgxEditorModule, Toolbar } from 'ngx-editor';
import { videoAssetGroups } from '@configs/videoTitles';
@Component({
  selector: 'app-choose-question-type',
  templateUrl: './choose-question-type.component.html',
  styleUrls: ['./choose-question-type.component.scss']
})
export class ChooseQuestionTypeComponent implements OnInit {
  setQuestionOption = true;
  setFillinthBlank = false;
  setDescriptive = false;
  setMatchAndOrder = false;
  setSurvey = false;
  setHotspot = false;
  flag: boolean = true;
  flag1: boolean = true;
  flag2: boolean = true;
  flag4: boolean = true;
  flag5: boolean = true;
  flag6: boolean = true;
  flag7: boolean = true;
  flag8: boolean = true;
  flag9: boolean = true;
  flag10: boolean = true;
  flag11: boolean = true;
  flag12: boolean = true;
  flag13: boolean = true;
  flag14: boolean = true;
  displaybtn: boolean = true;
  backbtnflag: boolean = false;
  flag3: boolean = true;
  setMatrix = false;
  tab: any = 'tab1';
  itemId: any;
  iteBankQueId: any;
  countries: any = ['Canada', 'Australia', 'Russia', 'Brazil'];
  options: any = [];
  questions: any = [];
  yesOrNo: any = [];
  Options: any = [];
  // options: any = ['Strongly Agree', 'Agree', 'Strongly Disagree', 'Disagree'];
  // questions: any = ['parent', 'neighbour', 'teacher', 'coach'];
  // yesOrNo: any = ['TRUE', 'FALSE'];
  // Options: any = ['Never', 'Rarely', 'Often', 'Always'];
  selectedOption: any = '1';
  @Output() backed = new EventEmitter();
  questionTypeName: any;
  questionType: number;
  questionSubTypeId:number;

  AIQue: any;
  radioButtons: boolean = true;
  scoringTypeId: any;
  ScoringTypeEnum = ScoringTypeEnum;
  // tab1 : any
  // tab2 : any
  // tab3 : any
  // tab4: any
  // tab5: any
  QuestionSubtypes: any;
  QuestionTypes: any;
  surveySubTypes: any;
  mcqSubType: any;
  questionTab$: Subscription;
  scoringTypeid$: Subscription;
  editor1: Editor;
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    // [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];
  videoLinks: any;
  allVideoLinks$: Subscription;
  videoAssetGroups = videoAssetGroups;
  evaluationMode: number;
  clicked = true;
  yourImageUrl = '../../../assets/logo/sparkplug.png'
  width: string = '100%';
  height: string = '600px';
  toolbarSettings1: Object = {
    items: ['undo', 'redo', 'clear', 'select', 'drawshape', 'drawrectangle', 'drawellipse', 'drawline', 'drawarrow', 'drawtext', 'zoom', 'pan']
  };
  image1: string = '../../../assets/logo/sparkplug.png';
  constructor(private router: Router, private routerstate: ActivatedRoute, private questionService: QuestionService, public translate: TranslateService, public itemService: ItemService) {


    this.iteBankQueId = this.router.getCurrentNavigation()?.extras?.state?.iteBankQueId;
    this.routerstate?.parent?.params?.subscribe(data => {
      this.itemId = data.id;
    });

    // Translate question options of array
    this.options = this.translate.instant('questions.matrix.choice1.options');
    this.questions = this.translate.instant('questions.matrix.choice1.questions');
    this.yesOrNo = this.translate.instant('questions.multipleChoice.choice3.yesOrNo');
    this.Options = this.translate.instant('questions.survey.choice1.Options');
    this.QuestionSubtypes = JSON.parse(sessionStorage.getItem('QuestionSubtypes'));
    this.QuestionTypes = JSON.parse(sessionStorage.getItem('Questiontypes'));
    this.surveySubTypes = this.QuestionTypes.items[4].subTypes.sort((a, b) => (a.questionSubTypeId - b.questionSubTypeId));
    this.mcqSubType = this.QuestionTypes.items[0].subTypes.sort((a, b) => (a.questionSubTypeId - b.questionSubTypeId));

    this.editor1 = new Editor();
  }


  groupName = ''
  ngOnInit(): void {
    this.scoringTypeId = sessionStorage.getItem('scoringTypeId');
    const userData = JSON.parse(sessionStorage.getItem('currentUser'));
    this.evaluationMode = userData.evaluationmode;

    if(this.evaluationMode === 1) {
      if(this.scoringTypeId == ScoringTypeEnum.OnQuestion) {  //question scoring
        this.gotoSurvey();
      }
      if(this.scoringTypeId == ScoringTypeEnum.OnOption) {    // scalar scoring
        this.gotoMultipleChoice()
      }
    } else if(this.evaluationMode === 2) {
      this.gotoMultipleChoice()
    }


    this.scoringTypeid$ = this.itemService.getScoringTypeId.subscribe(S => {
      if (S != "") {
        this.scoringTypeId = S;
          if (this.scoringTypeId == 2) {
            this.tab = 'tab1';
            this.setQuestionOption = true;
            this.setSurvey = false;
            this.radioButtons = true;
            this.setDescriptive = false;
            this.setMatchAndOrder = false;
          }
          if (this.scoringTypeId == 3) {
            this.tab = 'tab1';
            this.setQuestionOption = true;
            this.setSurvey = false;
            this.radioButtons = true;
            this.setDescriptive = false;
            this.setMatchAndOrder = false;
            this.setMatrix = false;
          }
          if(this.evaluationMode === 1) {
            if (this.scoringTypeId == 1) {
              this.tab = 'tab8';
              this.setSurvey = true;
              this.radioButtons = false
            }
          }
      }
    });
    // this.routerstate
    // .queryParams
    // .subscribe(params => {
    //   // Defaults to 0 if no query param provided.
    // });

    this.questionTab$ = this.itemService.getSelectedQuestionTab.subscribe(d => {
      if (d != "") {
        this.tab = d;
        switch(d) {
          case 'tab1': this.setQuestionOption = true;
          break;
          case 'tab8': this.setSurvey = true;
          this.setQuestionOption = false;
          this.radioButtons = false;
          break;
          case 'tab7': this.setMatrix = true;
          this.setQuestionOption = false;
          this.radioButtons = false;
          break;
          case 'tab2': this.setFillinthBlank = true;
          this.setQuestionOption = false;
          this.radioButtons = true;
          break;
          case 'tab3': this.setMatchAndOrder = true;
          this.setQuestionOption = false;
          this.radioButtons = false;
          break;
          case 'tab6': this.setDescriptive = true;
          this.setQuestionOption = false;
          this.radioButtons = true;
          break;
        }
      } else {
        this.tab = 'tab1';
      }
    });

    if (this.scoringTypeId == 2) this.groupName = videoAssetGroups.LikertScalerScoringQuestions;
    if (this.scoringTypeId == 3) this.groupName = videoAssetGroups.DISCScoring;
    if (this.scoringTypeId == 1) this.groupName = videoAssetGroups.QuestionScoring;
    this.allVideoLinks$ = this.itemService.videoTutorial(this.groupName).subscribe(video => {
      this.videoLinks = video.data;
      this.itemService.videoIcon.next(video.data);
    });
    // this.tab = 'tab1';
  }

  gotoHotspot() {
    this.clicked = true;
    this.radioButtons = false;
    this.tab = 'tab9';
    this.setQuestionOption = false;
    this.setFillinthBlank = false;
    this.setDescriptive = false;
    this.setMatrix = false;
    this.setSurvey = false;
    this.setHotspot = true;
    this.setMatchAndOrder = false;
    this.itemService.selectedQuestionTab.next('tab9');
    this.itemService.videoIcon.next(this.videoLinks);
  }

  navigateToHotspot() {
    this.flag1 = true;
    this.displaybtn = false;
    this.flag = true;
    this.flag2 = true;
    this.flag3 = true;
    this.flag4 = true;
    this.flag8 = true
    this.flag5 = true;
    this.flag9 = true;
    this.flag7 = true;
    this.flag6 = true;
    this.flag10 = true;
    this.flag11 = true;
    this.flag12 = true;
    this.flag13 = false;
    this.flag14 = true;
    this.itemService.videoIcon.next(this.videoLinks);
  }

  navigateToHotspotmultiChoice() {
    this.flag1 = true;
    this.displaybtn = false;
    this.flag = true;
    this.flag2 = true;
    this.flag3 = true;
    this.flag4 = true;
    this.flag8 = true
    this.flag5 = true;
    this.flag9 = true;
    this.flag7 = true;
    this.flag6 = true;
    this.flag10 = true;
    this.flag11 = true;
    this.flag12 = true;
    this.flag13 = true;
    this.flag14 = false;
    this.itemService.videoIcon.next(this.videoLinks);
  }

  navigateToAddQuestionsTyperadio() {

    if (this.selectedOption === '2') {
      this.questionSubTypeId = QuestionSubTypeIdEnum.MultipleChoiceStandard; // diff for question type in ai question page
      this.questionType = QuestionTypeIdEnum.MultipleChoiceStandard;
      this.questionTypeName = this.translate.instant('questions.typeOfQuestAiDriven.questionSection1.label21'); //this.QuestionTypes.items[0].queTypeDescription; //'multiple choice questions';
      this.AIQue = true;
      this.flag = false;
      this.displaybtn = false;
      this.flag1 = true;
      this.flag2 = true;
      this.flag3 = true
      this.flag4 = true
      this.flag7 = true;
      this.flag8 = true
      this.flag9 = true
      this.flag10 = true
      this.flag11 = true
      this.flag6 = true;
      this.flag12 = true;
    } else {
      this.flag = false;
      this.displaybtn = false;
      this.flag1 = true;
      this.flag2 = true;
      this.flag3 = true
      this.flag4 = true
      this.flag7 = true;
      this.flag8 = true
      this.flag9 = true
      this.flag10 = true
      this.flag11 = true
      this.flag6 = true;
      this.flag12 = true;
    }
    this.itemService.videoIcon.next(this.videoLinks);
    // state:{itemId:this.itemId,queId:ele.questionid}
    // this.router.navigate(["../addstandardmcquestion"], { relativeTo: this.routerstate, state: { itemId: this.itemId, iteBankQueId: this.iteBankQueId } });
  }

  navigateToAddQuestionsTypecheckbox() {
    if (this.selectedOption === '2') {
      this.questionSubTypeId = QuestionSubTypeIdEnum.MultipleChoiceOptions; // diff for question type in ai question page
      this.questionType = QuestionTypeIdEnum.MultipleChoiceOptions;
      this.questionTypeName = this.translate.instant('questions.typeOfQuestAiDriven.questionSection1.label21'); //this.QuestionTypes.items[0].queTypeDescription; //'multiple choice questions'
      this.AIQue = true;
      this.flag = true;
      this.displaybtn = false;
      this.flag1 = false;
      this.flag2 = true;
      this.flag3 = true
      this.flag4 = true
      this.flag7 = true;
      this.flag8 = true
      this.flag9 = true
      this.flag10 = true
      this.flag11 = true
      this.flag6 = true;
      this.flag12 = true;
    } else {
      this.flag1 = false;
      this.displaybtn = false;
      this.flag = true;
      this.flag7 = true;
      this.flag2 = true;
      this.flag3 = true;
      this.flag5 = true
      this.flag8 = true
      this.flag6 = true;
      this.flag4 = true;
      this.flag9 = true;
      this.flag10 = true;
      this.flag11 = true;
      this.flag12 = true;
    }
    this.itemService.videoIcon.next(this.videoLinks);
    // this.router.navigate(["../addstandardquestioncheckbox"], { relativeTo: this.routerstate, state: { itemId: this.itemId, iteBankQueId: this.iteBankQueId } });
  }
  navigateToAddQuestionsTypeTruFalse() {
    if (this.selectedOption === '2') {
      this.questionSubTypeId = QuestionSubTypeIdEnum.MultipleChoiceYesOrNo; // diff for question type in ai question page
      this.questionType = QuestionTypeIdEnum.MultipleChoiceYesOrNo;
      this.questionTypeName = this.translate.instant('questions.typeOfQuestAiDriven.questionSection1.label21'); //this.QuestionTypes.items[0].queTypeDescription; //'multiple choice questions'
      this.AIQue = true;
      this.flag = true;
      this.displaybtn = false;
      this.flag1 = true;
      this.flag2 = false;
      this.flag3 = true
      this.flag4 = true
      this.flag7 = true;
      this.flag8 = true
      this.flag9 = true
      this.flag10 = true
      this.flag11 = true
      this.flag6 = true;
      this.flag12 = true;
    } else {
      this.displaybtn = false;
      this.flag2 = false;
      this.flag1 = true;
      this.flag = true;
      this.flag4 = true;
      this.flag5 = true
      this.flag7 = true;
      this.flag8 = true
      this.flag9 = true;
      this.flag3 = true;
      this.flag6 = true;
      this.flag10 = true;
      this.flag11 = true;
      this.flag12 = true;
    }
    this.itemService.videoIcon.next(this.videoLinks);
    // this.router.navigate(["../addstandardquestiontruefalse"], { relativeTo: this.routerstate, state: { itemId: this.itemId, iteBankQueId: this.iteBankQueId } });
  }

  navigateToAddQuestionsMatrix() {
    this.flag1 = true;
    this.displaybtn = false;
    this.flag = true;
    this.flag2 = true;
    this.flag3 = true;
    this.flag4 = true;
    this.flag8 = true
    this.flag5 = false;
    this.flag9 = true;
    this.flag7 = true;
    this.flag6 = true;
    this.flag10 = true;
    this.flag11 = true;
    this.flag12 = true;
    this.itemService.videoIcon.next(this.videoLinks);
  }

  navigateToItemDetails(showFlag) {
    //  this.router.navigate(["./"]);
    //this.router.navigate(["../items"],{relativeTo: this.routerstate});
    //this.router.navigate(["/items/selectquestiontype"],{relativeTo: this.routerstate});
    // this.backbtnflag = true;
    //this.localStorage.setItem("backbtnflag","1");
    // localStorage.setItem("backbtnflag", "1");
    // this.backed.emit(showFlag);
    this.itemService.videoTutorial(videoAssetGroups.ItemManagementDetails).subscribe(video => {
      this.itemService.videoIcon.next(video.data);
    });
    this.itemService.selectedQuestionTab.next('tab1');
    this.questionService.backButtonObs.next(showFlag);
  }

  navigateToAddSurveyTyperadio() {
    this.displaybtn = false;
    this.flag7 = false;
    this.flag1 = true;
    this.flag = true;
    this.flag2 = true;
    this.flag3 = true;
    this.flag4 = true;
    this.flag5 = true;
    this.flag8 = true;
    this.flag8 = true;
    this.flag6 = true;
    this.flag10 = true;
    this.flag11 = true;
    this.flag12 = true;
    this.itemService.videoIcon.next(this.videoLinks);
  }
  navigateToAddSurveyMultiTyperadio() {
    this.displaybtn = false;
    this.flag7 = true;
    this.flag1 = true;
    this.flag = true;
    this.flag2 = true;
    this.flag3 = true;
    this.flag4 = true;
    this.flag5 = true;
    this.flag7 = true;
    this.flag8 = false;
    this.flag6 = true;
    this.flag10 = true;
    this.flag11 = true;
    this.flag12 = true;
    this.itemService.videoIcon.next(this.videoLinks);

  }

  navigateToFillInTheBlank() {
    if (this.selectedOption === '2') {
      this.questionSubTypeId = QuestionSubTypeIdEnum.FillInTheBlanks; // diff for question type in ai question page
      this.questionType = QuestionTypeIdEnum.FillInTheBlanks;
      this.questionTypeName = this.translate.instant('questions.typeOfQuestAiDriven.questionSection1.label22'); //this.QuestionTypes.items[1].queTypeDescription; //'Fill in the blanks questions'
      this.AIQue = true;
      this.flag = true;
      this.displaybtn = false;
      this.flag1 = true;
      this.flag2 = true;
      this.flag3 = false
      this.flag4 = true
      this.flag7 = true;
      this.flag8 = true
      this.flag9 = true
      this.flag10 = true
      this.flag11 = true
      this.flag6 = true;
      this.flag12 = true;
    } else {
      this.flag1 = true;
      this.displaybtn = false;
      this.flag = true;
      this.flag2 = true;
      this.flag3 = false;
      this.flag4 = true;
      this.flag5 = true;
      this.flag7 = true;
      this.flag9 = true;
      this.flag8 = true;
      this.flag6 = true;
      this.flag10 = true;
      this.flag11 = true;
      this.flag12 = true;
      this.setFillinthBlank = false;
      this.setMatrix = true
    }
    this.itemService.videoIcon.next(this.videoLinks);

  }

  navigateToAddshortanswar() {

    this.displaybtn = false;
    this.flag = true;
    this.flag1 = true;
    this.flag2 = true;
    this.flag3 = true;
    this.flag4 = true;
    this.flag8 = true
    this.flag5 = true;
    this.flag7 = true;
    this.flag9 = false;
    this.flag6 = true;
    this.flag10 = true;
    this.flag11 = true;
    this.flag12 = true;
    this.itemService.videoIcon.next(this.videoLinks);
  }

  navigateToSurveyLikedislike() {
    this.displaybtn = false;
    this.flag = true;
    this.flag1 = true;
    this.flag2 = true;
    this.flag3 = true;
    this.flag4 = true;
    this.flag8 = true
    this.flag5 = true;
    this.flag7 = true;
    this.flag6 = false;
    this.flag9 = true;
    this.flag10 = true;
    this.flag11 = true;
    this.flag12 = true;
    this.itemService.videoIcon.next(this.videoLinks);
  }

  navigateToSurveyStarRating() {
    this.displaybtn = false;
    this.flag = true;
    this.flag1 = true;
    this.flag2 = true;
    this.flag3 = true;
    this.flag4 = true;
    this.flag8 = true
    this.flag5 = true;
    this.flag7 = true;
    this.flag6 = true;
    this.flag9 = true;
    this.flag10 = false;
    this.flag11 = true;
    this.flag12 = true;
    this.itemService.videoIcon.next(this.videoLinks);
  }

  navigateToSurveyNumberRating() {
    this.displaybtn = false;
    this.flag = true;
    this.flag1 = true;
    this.flag2 = true;
    this.flag3 = true;
    this.flag4 = true;
    this.flag8 = true
    this.flag5 = true;
    this.flag7 = true;
    this.flag6 = true;
    this.flag9 = true;
    this.flag10 = true;
    this.flag11 = false;
    this.flag12 = true;
    this.itemService.videoIcon.next(this.videoLinks);
  }
  gotoMultipleChoice() {
    this.clicked = true;
    this.radioButtons = true;
    this.tab = 'tab1';
    this.setQuestionOption = true;
    this.setFillinthBlank = false;
    this.setDescriptive = false;
    this.setMatrix = false;
    this.setSurvey = false;
    this.setHotspot = false;
    this.setMatchAndOrder = false;
    this.itemService.selectedQuestionTab.next('tab1');
    this.itemService.videoIcon.next(this.videoLinks);
  }

  gotoMatrix() {
    this.clicked = false
    this.radioButtons = false;
    this.tab = 'tab7';
    this.setQuestionOption = false;
    this.setFillinthBlank = false;
    this.setMatrix = true;
    this.setDescriptive = false;
    this.setSurvey = false;
    this.setMatchAndOrder = false;
    this.setHotspot = false;
    this.itemService.selectedQuestionTab.next('tab7');
    this.itemService.videoIcon.next(this.videoLinks);
  }

  gotoSurvey() {
    this.radioButtons = false;
    this.tab = 'tab8';
    this.setFillinthBlank = false;
    this.setSurvey = true;
    this.setQuestionOption = false;
    this.setDescriptive = false;
    this.setMatrix = false
    this.setMatchAndOrder = false;
    this.setHotspot = false;
    this.itemService.selectedQuestionTab.next('tab8');
    this.itemService.videoIcon.next(this.videoLinks);
  }
  gotFillinthBlank() {
    this.radioButtons = true;
    this.tab = 'tab2';
    this.setFillinthBlank = true;
    this.setDescriptive = false;
    this.setMatrix = false;
    this.setSurvey = false;
    this.setQuestionOption = false;
    this.setMatchAndOrder = false;
    this.setHotspot = false;
    this.itemService.selectedQuestionTab.next('tab2');
    this.itemService.videoIcon.next(this.videoLinks);
  }
  gotoMatchandOrders() {
    this.radioButtons = false;
    this.tab = 'tab3';
    // this.displaybtn = false;
    this.setMatrix = false;
    this.setMatchAndOrder = true;
    this.setQuestionOption = false;
    this.setFillinthBlank = false;
    this.setSurvey = false;
    this.setDescriptive = false;
    this.setHotspot = false;
    this.itemService.selectedQuestionTab.next('tab3');
    this.itemService.videoIcon.next(this.videoLinks);
  }
  gotoDiscriptive() {
    this.radioButtons = true;
    this.tab = 'tab6';
    this.setQuestionOption = false;
    this.setFillinthBlank = false;
    this.setMatrix = false;
    this.setSurvey = false;
    this.setDescriptive = true;
    this.setMatchAndOrder = false;
    this.setHotspot = false;
    this.itemService.selectedQuestionTab.next('tab6');
    this.itemService.videoIcon.next(this.videoLinks);
  }

  navigateDescriptive() {
    if (this.selectedOption === '2') {
      this.questionSubTypeId = QuestionSubTypeIdEnum.Descriptive; // diff for question type in ai question page
      this.questionType = QuestionTypeIdEnum.Descriptive;
      this.questionTypeName = this.translate.instant('questions.typeOfQuestAiDriven.questionSection1.label23'); // this.QuestionTypes.items[3].queTypeDescription; //'Descriptive questions'
      this.AIQue = true;
      this.flag = true;
      this.displaybtn = false;
      this.flag1 = true;
      this.flag2 = true;
      this.flag3 = true
      this.flag4 = false
      this.flag7 = true;
      this.flag8 = true
      this.flag9 = true
      this.flag10 = true
      this.flag11 = true
      this.flag6 = true;
      this.flag12 = true;
    } else {
      this.flag1 = true;
      this.displaybtn = false;
      this.flag = true;
      this.flag2 = true;
      this.flag3 = true;
      this.flag4 = false;
      this.flag5 = true
      this.setDescriptive = false;
      this.setMatrix = false;
    }
    this.itemService.videoIcon.next(this.videoLinks);

  }
  navigateMatchOrder() {
    this.displaybtn = false;
    this.flag = true;
    this.flag1 = true;
    this.flag2 = true;
    this.flag3 = true;
    this.flag4 = true;
    this.flag8 = true
    this.flag5 = true;
    this.flag7 = true;
    this.flag6 = true;
    this.flag9 = true;
    this.flag10 = true;
    this.flag11 = true;
    this.flag12 = false;

    this.itemService.videoIcon.next(this.videoLinks);
  }

  gotoFreeText() {
    this.tab = 'tab4';
    this.itemService.selectedQuestionTab.next('tab4');
    this.setQuestionOption = false;
    this.setMatrix = false;

  }


  ngOnDestroy(): void {
    if (this.allVideoLinks$) { this.allVideoLinks$.unsubscribe(); }
  }
}
